import {TemplateResult, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import ToolButtonElement from 'gmfapi/elements/ToolButtonElement';
import 'bootstrap/js/src/tooltip';
import {Subscription} from 'rxjs';
import {msg, localized} from '@lit/localize';
import {css} from 'lit';

@localized()
@customElement('geoshop-button')
export class ToolButtonGeoshopOpen extends ToolButtonElement {
  @property({type: String}) lang: string = 'de';
  private subscriptions: Subscription[] = [];
  private active_: boolean = false;

  static styles = css`
    .fa-cart-shopping {
      display: inline-block;
      width: 24px;
      height: 24px;
      vertical-align: middle;
      border: none;
      background: none;
    }
  `;

  constructor() {
    super('geoshop');
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  render(): TemplateResult {
    return html`
      <button
        part="button"
        @click=${() => {
          this.click_();
        }}
        class="${this.active_ ? 'active' : ''}"
        data-toggle="tooltip"
        data-placement="left"
        data-original-title="${msg('Shop')}"
      >
        <span class="fa-solid fa-cart-shopping"></span>
      </button>
    `;
  }
}
